import styled from "styled-components";

export const TaskListWrapper = styled.div`
  width: 100%;
  padding-right: 10px;
`;
